import styled from 'styled-components'
import { cyberColors } from '../../../lib/colors'

interface Audio_Style_Props {
  music?: boolean
  opacity?: number
}
export const AudioWrapper = styled.div<Audio_Style_Props>`
  display: flex;
  align-items: center;
  margin: 16px 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 38px;
  background: ${cyberColors.greyDark};
  padding: 18px;
  border-radius: 4px;
  margin-bottom: 15px;
  .track {
    display: flex;
    width: 200px;
    height: 6px;
    position: absolute;
    top: 16px;
    pointer-events: none;
    border-radius: 8.16327px;
    z-index: 0;
  }
  .track-inner {
    width: 50%;
    height: 100%;
    background: ${({ music }) =>
      music ? cyberColors.blueGradient : cyberColors.redGradient};
    border-radius: 8.16327px;
    border: 1px solid rgba(84, 84, 104, 0.3);
    background-clip: content-box;
    z-index: 0;
  }
  .thumb {
    width: 28px;
    height: 28px;
    border: 0;
    z-index: 99 !important;
    cursor: pointer;
    transform: translateY(-11.5px) translateX(-50%);
    position: absolute;
    left: 50%;
  }
  .track-outter {
    width: 50%;
    height: 100%;
    border: 1px solid rgba(84, 84, 104, 0.3);
    border-radius: 8.16327px;
    background: #545468;
    background-clip: content-box;
    z-index: 2;
  }
  input {
    width: 200px;
    height: 6px;
    background: transparent;
    border-radius: 8.16327px;
    -webkit-appearance: none !important;
    z-index: 1;
    opacity: 0;
    &&:focus {
      outline: none;
    }
    ::-webkit-slider-runnable-track {
      -webkit-appearance: none;
    }
    ::-moz-slider-thumb {
      -moz-appearance: none;
    }
    ::-webkit-slider-thumb {
      width: 28px;
      height: 28px;
      border: 0;
      z-index: 99 !important;
      cursor: pointer;
      -webkit-appearance: none;
    }
  }
`

export const Label = styled.div`
  font-size: 22px;
  text-transform: capitalize;
  color: ${cyberColors.greyText};
  margin-left: 9px;
  position: absolute;
  z-index: 1;
  left: 0;
  pointer-events: none;
`
export const Icon = styled.div<Audio_Style_Props>`
  position: absolute;
  z-index: 1;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px;
  background: ${({ music }) =>
    music ? cyberColors.blueGradient : cyberColors.redGradient};
  border-radius: 4px;
  width: 38px;
  height: 38px;
  opacity: 0.9;
  cursor: pointer;
  :active,
  :hover {
    svg {
      path {
        stroke: ${({ music }) => (music ? '#BAC7FB' : '#FFB5B5')};
        transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 0.167s;
      }
    }
  }
  svg {
    path {
      stroke: ${({ music }) => (music ? '#7E97FA' : '#FA7E7E')};
      transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
      transition: all 0.167s;
    }
  }
  .off {
    /* width: 6px; */
    margin-left: 2px;
  }
`
export const VolumeOn = styled.div<Audio_Style_Props>`
  display: flex;
  align-items: center;
  margin-left: 2px;

  /* width: 7px;  */
`
